import { targets } from "../../Context";
import SharedKillsHeatmap from "../shared/KillsHeatmap";

export default function KillsHeatmap() {
    return <SharedKillsHeatmap target={targets.scrims} />;
}
